<template>
  <span style="display:inline-block;">
    <!-- ── Tooltip ------------------------------------------------------- -->
    <div v-if="showTooltip" class="mytooltip" :style="positionTop">
      <span class="mytooltip-text" >{{ tooltip }}</span>
    </div>
    <!-- ── Icon button --------------------------------------------------- -->
    <a
      ref="buttonRef"
      class="btn btn-icon btn-light btn-sm mem-btn"
      @click.prevent="handleClick"
      @mouseenter="onMouseEnter"
      @mouseleave="onMouseLeave"
      style="position: relative;"
    >
      <!-- Notification -->
      <div class="notification-circle" v-if="notification">
        <span>{{notification}}</span>
      </div>

      <!-- Icon -->
      <span class="ml-svg-icon svg-icon-md svg-icon-primary-blue">
        <i v-if="icon" :class="icon"></i>
        <inline-svg v-else-if="svg" :src="svg"></inline-svg>
      </span>
    </a>

  </span>
</template>

<script>

export default {
  name  : 'MemlistIconButton',
  props : {
    disabled: { type:Boolean, default:false },
    icon   : { type:String, default:null }, // e.g. 'fas fa-star'
    svg    : { type:String, default:null }, // path or import to .svg file
    tooltip: { type:String, default:'' },
    notification: { type: Number, default: null }
  },
  emits : ['click'],
  data  : () => ({
    showTooltip: false,
    tooltipTop: 0,
    tooltipLeft: 0,

  }),
  mounted() {

  },
  computed: {
    positionTop() {
      return {
        top: this.tooltipTop + 'px',
        left: this.tooltipLeft + 'px',
        transform: 'translateX(-50%)'
      };
    }
  },
  methods: {
    
    onMouseEnter(event) {
      const mouseX = event.clientX;
      const mouseY = event.clientY;

      this.tooltipTop = mouseY + window.scrollY - 20;  // Tooltip 40px above mouse
      this.tooltipLeft = mouseX + window.scrollX;      // Centered at mouse X

      this.showTooltip = this.tooltip ? true : false;
    },
    onMouseLeave() {
      this.showTooltip = false;
    },
    handleClick () {
      if (this.disabled) {
        return;
      }

      this.$emit('click');
    }
  }
};
</script>

<style lang="scss" scoped>

.notification-circle {
  position: absolute;
  top: -6px;
  right: -6px;
  background-color: #ff3800;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.notification-circle span {
  margin-left: -1px;
  text-align: center;
  width: 18px;
}

.mytooltip {
  position: fixed;
  z-index:99999;
}
.mytooltip-text {
  position: absolute;
  left:-100px; 
  top:-40px;
  min-width:220px; 
  margin-left:-80px;
  z-index:99999;
  background:#fff;
  border:1px solid #3699ff;
  padding:5px; border-radius:8px;
  text-align:center;
  overflow:hidden; text-overflow:ellipsis;
}

/* ───── Button hover colour (CSS – no JS needed) ────────────────────── */
.mem-btn          { 
  transition:background-color .15s; }
.mem-btn:hover    { background-color:lightblue; }

/* ───── Make sure SVG never captures the mouse pointer ──────────────── */
.mem-btn .svg-icon,
.mem-btn .svg-icon * { pointer-events:none; }

.ml-svg-icon  {
  width: 20px;
  height: 20px;
}


.ml-svg-icon svg {
  width: 20px;
  height: 20px;
}

/* ───── Brand‑blue helper for inline SVGs using `currentColor` ──────── */
.svg-icon-primary-blue,
.svg-icon-primary-blue * {
  color:#3699FF !important;
  fill:currentColor !important;   /* inline‑svg paths follow the colour */
}
</style>
